import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { convertNestedToDotNotation } from '../../../pages/onboardingPageV2/helpers/convertObjToHistory';
import { ShownTypes } from '../onboarding-history/types';
import { sortFields } from '../onboarding-history/sortByStartDate';

interface CompanyHistory {
    companyId: string;
    count: number;
}

interface CompanyHistoryState {
    total: Record<string, CompanyHistory[]>;
    activeFields: Record<string, Array<Record<string, unknown>>>;
    historyFields: Record<string, Array<Record<string, unknown>>>;
}

const initialState: CompanyHistoryState = {
    total: {},
    activeFields: {},
    historyFields: {},
};

const onboardingCompanyHistorySlice = createSlice({
    name: 'onboardingCompanyHistory',
    initialState,
    reducers: {
        setTotalHistoryCompany(state, action) {
            state.total = action.payload;
        },
        setAllFieldsWC(state, action) {
            const fields = convertNestedToDotNotation(action.payload) as Record<string, Array<any>>;

            state.activeFields = {};
            state.historyFields = {};

            Object.keys(fields).forEach((key) => {
                state.activeFields[key] = fields[key].filter((item) => item.isActive);
                state.historyFields[key] = fields[key].filter((item) => !item.isActive);
            });

            sortFields(state);
        },

        setActiveFieldsCompany(state, action) {
            const fields = convertNestedToDotNotation(action.payload) as any;
            state.activeFields = fields;
            // Object.keys(fields).forEach((key: any) => {
            //   if (!fields[key] || !fields[key]?.length) {
            //     state.activeFields[key] = [
            //       // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //       //@ts-ignore
            //       initialHistoryFields[key].reduce((acc: any, element: any) => {
            //         acc[element.key] =
            //           element.inputType === 'number'
            //             ? 0
            //             : element.type === ShownTypes.uploadFile
            //               ? []
            //               : element.type === ShownTypes.checkbox ||
            //                 element.type === ShownTypes.switch ||
            //                 element.type === ShownTypes.radio
            //                 ? false
            //                 : '';
            //         return acc;
            //       }, {} as Record<string, string | boolean | undefined>),
            //     ];
            //   }
            // });
            Object.keys(fields).forEach((key) => {
                if (!state.historyFields[key]) {
                    state.historyFields[key] = [];
                }
            });
            // sortFields(state);
        },

        setHistoryFieldsCompany(state, action) {
            const newHistoryFields = convertNestedToDotNotation(action.payload);

            Object.keys(newHistoryFields).forEach((key) => {
                if (!state.historyFields[key]) {
                    state.historyFields[key] = newHistoryFields[key];
                } else {
                    const mergedArray = [...state.historyFields[key], ...newHistoryFields[key]];

                    const uniqueArray = mergedArray.filter(
                        (item, index, self) => !item._id || index === self.findIndex((t) => t._id === item._id)
                    );

                    state.historyFields[key] = uniqueArray;
                }
            });
            // sortFields(state);
        },

        addNewActiveFieldCompany(
            state,
            action: PayloadAction<{
                fieldKey: string;
                newField: Record<string, unknown>;
            }>
        ) {
            const { fieldKey, newField } = action.payload;
            const companyId = newField.companyId as string;
            if (!state.total[fieldKey]) state.total[fieldKey] = [];

            if (state.activeFields[fieldKey].filter((item) => item.companyId === companyId).length > 1) {
                state.historyFields[fieldKey]
                    .filter((item) => item.companyId === companyId)
                    .unshift(state.activeFields[fieldKey][1]);
                const company = state.total[fieldKey].find((item) => item.companyId === companyId);
                if (company) {
                    company.count += 1;
                } else {
                    state.total[fieldKey].push({ companyId, count: 1 });
                }
                state.activeFields[fieldKey] = [newField, state.activeFields[fieldKey][0]];
                return;
            }

            state.activeFields[fieldKey].unshift(newField);
            // sortFields(state);
        },

        moveToHistoryCompany(
            state,
            action: PayloadAction<{
                fieldKey: string;
                index: number;
                newField: Record<string, unknown>;
            }>
        ) {
            const { fieldKey, index, newField } = action.payload;
            const companyId = newField.companyId as string;

            if (!state.historyFields[fieldKey]) {
                state.historyFields[fieldKey] = [];
            }
            if (!state.activeFields[fieldKey]) {
                state.activeFields[fieldKey] = [];
            }
            if (!state.total[fieldKey]) {
                state.total[fieldKey] = [];
            }

            const [removed] = state.activeFields[fieldKey]
                .filter((item) => item.companyId === companyId)
                .splice(index, 1);
            console.log(removed);
            const oldFields = state.activeFields[fieldKey].filter((item) => item.companyId !== companyId);
            const newFields = state.activeFields[fieldKey]
                .filter((item) => item.companyId === companyId)
                .filter((item, indexCompany) => indexCompany !== index);
            state.activeFields[fieldKey] = [...oldFields, ...newFields];
            if (removed) {
                state.historyFields[fieldKey] = [...state.historyFields[fieldKey], removed];
            }

            const company = state.total[fieldKey].find((item) => item.companyId === companyId);
            if (company) {
                company.count += 1;
            } else {
                state.total[fieldKey].push({ companyId, count: 1 });
            }

            // const hasActiveFieldsForCompany = state.activeFields[fieldKey].some(
            //   (item) => item.companyId === companyId,
            // );

            // if (!hasActiveFieldsForCompany) {
            //   state.activeFields[fieldKey].push(newField);
            // }

            // sortFields(state);
        },

        moveToActiveCompany(
            state,
            action: PayloadAction<{
                fieldKey: string;
                index: number;
                companyId: string | undefined;
            }>
        ) {
            const { fieldKey, index, companyId } = action.payload;

            if (!state.historyFields[fieldKey] || !state.historyFields[fieldKey][index]) {
                return;
            }

            const removed = state.historyFields[fieldKey]
                .filter((item) => item.companyId === companyId)
                .splice(index, 1)[0];

            if (!state.activeFields[fieldKey]) {
                state.activeFields[fieldKey] = [];
            }

            state.activeFields[fieldKey] = [...state.activeFields[fieldKey], removed];
            const oldFields = state.historyFields[fieldKey].filter((item) => item.companyId !== companyId);
            const newHistory = state.historyFields[fieldKey]
                .filter((item) => item.companyId === companyId)
                .filter((item, indexCompany) => {
                    return indexCompany !== index;
                });
            state.historyFields[fieldKey] = [...oldFields, ...newHistory];

            const company = state.total[fieldKey]?.find((item) => item.companyId === companyId);
            if (company) {
                company.count -= 1;
                if (company.count <= 0) {
                    state.total[fieldKey] = state.total[fieldKey].filter((item) => item.companyId !== companyId);
                }
            }
            // sortFields(state);
        },

        removeFromActiveFieldCompany(
            state,
            action: PayloadAction<{
                fieldKey: string;
                index: number;
                newField: Record<string, unknown>;
            }>
        ) {
            const { fieldKey, index, newField } = action.payload;
            const companyId = newField.companyId as string;

            state.activeFields[fieldKey].splice(index, 1);
            // if (
            //   !state.activeFields[fieldKey].some(
            //     (item) => item.companyId === companyId,
            //   )
            // ) {
            //   state.activeFields[fieldKey].push(newField);
            // }
            // sortFields(state);
        },

        removeFromHistoryFieldCompany(
            state,
            action: PayloadAction<{
                fieldKey: string;
                index: number;
                companyId: string | undefined;
            }>
        ) {
            const { fieldKey, index, companyId } = action.payload;

            if (
                !state.historyFields[fieldKey] ||
                !state.historyFields[fieldKey].filter((item) => item.companyId === companyId)[index]
            ) {
                return;
            }
            const oldFields = state.historyFields[fieldKey].filter((item) => item.companyId !== companyId);
            const newHistory = state.historyFields[fieldKey]
                .filter((item) => item.companyId === companyId)
                .filter((item, indexCompany) => {
                    return indexCompany !== index;
                });
            state.historyFields[fieldKey] = [...oldFields, ...newHistory];

            const company = state.total[fieldKey]?.find((item) => item.companyId === companyId);
            if (company) {
                company.count -= 1;
                if (company.count <= 0) {
                    state.total[fieldKey] = state.total[fieldKey].filter((item) => item.companyId !== companyId);
                }
            }
            // sortFields(state);
        },

        resetAllFieldsCompany(state) {
            state.total = {};
            state.activeFields = {};
            state.historyFields = {};
        },
        changeActiveFieldCompany(
            state,
            action: PayloadAction<{
                fieldKey: string;
                index: number;
                value: any;
                changedField: string;
                companyId: string | undefined;
            }>
        ) {
            const { fieldKey, index, value, changedField, companyId } = action.payload;
            const items = state.activeFields[fieldKey].filter((item) => item.companyId === companyId);

            if (items[index]) {
                items[index][changedField] = value;
            }
        },

        changeHistoryFieldCompany(
            state,
            action: PayloadAction<{
                fieldKey: string;
                index: number;
                value: any;
                changedField: string;
                companyId: string | undefined;
            }>
        ) {
            const { fieldKey, index, value, changedField, companyId } = action.payload;
            const items = state.historyFields[fieldKey].filter((item) => item.companyId === companyId);

            if (items[index]) {
                items[index][changedField] = value;
            }
        },
    },
});

export const {
    setTotalHistoryCompany,
    setActiveFieldsCompany,
    setHistoryFieldsCompany,
    addNewActiveFieldCompany,
    moveToActiveCompany,
    moveToHistoryCompany,
    removeFromActiveFieldCompany,
    removeFromHistoryFieldCompany,
    resetAllFieldsCompany,
    changeHistoryFieldCompany,
    changeActiveFieldCompany,
    setAllFieldsWC,
} = onboardingCompanyHistorySlice.actions;

export default onboardingCompanyHistorySlice.reducer;
